/* @flow */
/**
 * For non-declarative behavior of routes
 */
import AuthActions from 'auth/AuthActions';
import CurrentUser from 'auth/CurrentUser';
import User from 'entities/User';

import type { RouterState, LocationDescriptor } from 'lib/ReactRouterTypes';

// TODO move resolveDeepLinkRedirects into here

// TODO simplify our user state
export function promiseUser(): Promise<User> {
  if (CurrentUser.isSignedIn()) {
    return Promise.resolve(CurrentUser.getUser());
  } else {
    return AuthActions.checkLoggedIn();
  }
}

export function goLandingIfAuthed(nextState: RouterState, replaceWith: (location: LocationDescriptor) => void) {
  if (CurrentUser.isSignedIn()) {
    replaceWith('/landing');
  }
}

export function goToClassCode(nextState: RouterState, replaceWith: (location: LocationDescriptor) => void) {
  replaceWith(`/classes/${nextState.params.groupCode}`);
}

// @deprecated using in onEnter makes first CSR blank, breaking clean rehydration with SSR
export function goToClassCodeIfAuthed(nextState: RouterState, replaceWith: (location: LocationDescriptor) => void, callback: Function) {
  promiseUser()
    .then(() => {
      goToClassCode(nextState, replaceWith);
      callback();
    }, () => callback());
}

// This is just to make testing easier
export function hardRedirectTo(redirectTo: string) {
  window.location.href = redirectTo;
}



// WEBPACK FOOTER //
// ./src/lib/RouteLogic.js